import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';

import { ContactDetail } from '../styles';
import { ContactTextOrLink } from './ContactTextOrLink';

interface Props {
  title: string;
  contactDetail: string;
  contactType: string;
}

export const ContactRow = ({ title, contactDetail, contactType }: Props) => {
  return (
    <Grid item xs={12}>
      <Grid container>
        <Grid item xs={5}>
          <Typography variant="body2">{title}</Typography>
        </Grid>
        <ContactDetail item xs={7}>
          <ContactTextOrLink contactDetail={contactDetail} contactType={contactType} />
        </ContactDetail>
      </Grid>
    </Grid>
  );
};
